/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { LeaveOrganizationMutationResponse, LeaveOrganizationPathParams, LeaveOrganization400, LeaveOrganization401, LeaveOrganization403, LeaveOrganization404, LeaveOrganization409, LeaveOrganization500 } from "../../types/organizationController/LeaveOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getLeaveOrganizationUrl(organizationId: LeaveOrganizationPathParams["organizationId"]) {
  const res = { method: 'DELETE', url: `/api/organizations/${organizationId}/leave` as const }
  return res
}

/**
 * @summary Leave organization
 * {@link /api/organizations/:organizationId/leave}
 */
export async function leaveOrganization(organizationId: LeaveOrganizationPathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<LeaveOrganizationMutationResponse, ResponseErrorConfig<LeaveOrganization400 | LeaveOrganization401 | LeaveOrganization403 | LeaveOrganization404 | LeaveOrganization409 | LeaveOrganization500>, unknown>({ method : "DELETE", url : getLeaveOrganizationUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}